import React from "react";
import { getLastUpdated } from '../utils/getLastUpdated';

function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#040f1f] to-[#020a14] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <a href="/" className="flex items-center space-x-2 mb-4">
              <img src="/logo_head_clean_transparent_small.png" alt="DataPulse AI" className="w-8 h-8" />
              <span className="text-white font-bold text-lg">DataPulse AI</span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed">
              Building technology that makes human connection magical.
            </p>
          </div>

          {/* Products Column */}
          <div>
            <h4 className="text-white font-semibold mb-4">Products</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.convu.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Convu.ai
                </a>
              </li>
              <li>
                <a href="https://www.foodu.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Foodu.ai
                </a>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.mydatapulse.co.uk" className="text-gray-400 hover:text-white transition-colors text-sm">
                  DataPulse Web
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/appointment" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Book a Call
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/trademark" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Trademark Attribution
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} DataPulse AI. All rights reserved.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/100454300"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm border border-gray-600 hover:border-gray-400 rounded-full px-4 py-2"
              >
                <img src="/icons/linkedin.svg" alt="LinkedIn" className="w-4 h-4" />
                <span>Follow us</span>
              </a>
            </div>
          </div>

          {/* Last Updated */}
          <p className="text-gray-600 text-xs text-center mt-6">
            Last updated: {getLastUpdated()}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
